import {history} from './history';

// Keep existing dispatch(push(path)) callers while React Router owns history.
export const push = (path: string) => () => history.push(path);
